import { Link } from "wouter";
import ClarityOneLayout from "@/components/clarity-one/ClarityOneLayout";

/** Customer-safe page for unknown routes on one.claritygroup.com.sg */
export default function ClarityOneNotFoundPage() {
  return (
    <ClarityOneLayout showNav={false}>
      <div className="text-center py-16 px-4">
        <p className="text-xs tracking-[0.2em] uppercase text-[#8B7355] mb-3">Clarity One</p>
        <h1 className="text-2xl font-light text-[#1A2744] mb-3">Page not found</h1>
        <p className="text-sm text-[#8B7355] leading-relaxed max-w-sm mx-auto mb-8">
          This page isn&apos;t part of your Clarity One portal. If you were looking for your wallet or account,
          use the links below.
        </p>
        <div className="flex flex-col gap-3 max-w-xs mx-auto">
          <Link
            href="/login"
            className="block no-underline rounded-xl bg-[#1A2744] text-white py-3 text-sm font-medium hover:bg-[#243556] transition-colors"
          >
            Sign in
          </Link>
          <Link
            href="/home"
            className="block no-underline rounded-xl border border-[#E8E4DC] text-[#1A2744] py-3 text-sm hover:border-[#C8A96A] transition-colors"
          >
            Go to home
          </Link>
        </div>
      </div>
    </ClarityOneLayout>
  );
}
